<template>

  <div class="custom-tab">
    <div class="custom-tab-header">
      <b-row class="updates-page mr-0">
        <div>
          <b-row class="m-0">
            <b-col class="pr-0">
              <b-form-select class="primary-select" v-model="selectedView" :options="views" />
            </b-col>
            <b-col class="p-0 pl-2">
              <b-form-select class="primary-select" v-model="selectedGroup">
                <template slot="first">
                  <option :value="null">All Websites</option>
                </template>
                <option v-for="group in getGroups" :key="group.groupID" :value="group.groupID">{{group.name}}</option>
              </b-form-select>
            </b-col>
            <b-col class="p-0 pl-2">
              <div class="d-flex">
                <span class="label">View:</span>
                <b-form-radio-group button-variant="outline-custom" label= "view" buttons v-model="viewIgnore" :options="options" class="active"></b-form-radio-group>
              </div>
            </b-col>
          </b-row>
        </div>
        <div>
          <div class="text-right">
            <b-button size="lg" class="updateallbtn" variant="primary" @click="updateAll()">
              <update-all-icon class="icon-default updateall"></update-all-icon>
              Update All</b-button>
          </div>
        </div>
      </b-row>   
    </div>
    <div class="custom-tab-body hasfooter">
      <div v-if="isLoading">
        <spinner size="small"></spinner>
      </div>
      <website-view v-if="selectedView === 'website' && !isLoading" :selectedUpdatesCount="selectedUpdatesCount" :searchtext.sync="search"  :entities="updatesBySite" :buttonLoaders="buttonLoaders" :viewIgnore="viewIgnore" :showUpdateStaging="showUpdateStaging" @selectAll="select" @paginatevalue="dynamicPagination" @action="updatePagination" @update="update" @ignore="ignore" @unIgnore="unIgnore"></website-view>
      <entity-updater v-if="selectedView !== 'website'" :searchtext.sync="search" :entities="updates[selectedView]" :type="selectedView" :buttonLoaders="buttonLoaders" :viewIgnore="viewIgnore" @selectAll="select" @update="update" @ignore="ignore" @unIgnore="unIgnore"></entity-updater>
    </div>
    <update-modal ref="updatemodal" :updates="rawUpdates" @yes="update"></update-modal>
  </div>

</template>

<script>
import Vue from 'vue';
import UpdateAllIcon from '../../assets/updateAll.svg';
import PluginIcon from '../../assets/plugins.svg';
import ThemeIcon from '../../assets/themes.svg';
import WordpressIcon from '../../assets/wordpress.svg';
import TranslationIcon from '../../assets/translation.svg';
import WebsiteView from '../Manage/WebsiteView';
import EntityUpdater from '../Manage/EntityUpdater';
import updateModal from '../modals/UpdateModal';
import EmptyPlaceholder from '../Common/EmptyPlaceholder';
import {EventBus} from '../../event/event-bus.js';

export default {
  name: 'updates',
  components: {
    EntityUpdater,
    WebsiteView,
    updateModal,
    UpdateAllIcon,
    PluginIcon,
    WordpressIcon,
    TranslationIcon,
    ThemeIcon,
    EmptyPlaceholder
   
  },
  data() {
    return {
      buttonLoaders: {
        update: false,
        ignore: false,
        unIgnore: false
      },
      currentTabIndex: 0,
      selectedUpdates: [],
      showUpdatePopup: false,
      selectedView : "website",
      selectedGroup : null,
      viewIgnore: false,
      options: [
        { text: 'All', value: false },
        { text: 'Ignored', value: true },
      ],
      views: [
        { text: 'Website', value: "website"},
        { text: 'Plugins', value: "plugins"},
        { text: 'Themes', value: "themes"},
        { text: 'Core', value: "core"},
        { text: 'Translations', value: "translations"}
      ],
      groups: [
        { text: 'All Websites', value: "website"}
      ],
      placeholderProps: {
        text: () => {
          return `Looks like there are no updates available`;
        },
        type: 'positive'
      },
      search:"",
      isLoading:true,
      paginate: 20,
      selectedUpdatesCount: 0
    };
  },
  computed: {
    sites() {
      return this.$store.getters.getSites;
    },
    getSelectedSites() {
      return this.$store.getters.selectedSites;
    },
    getSitesUpdates() {
      return this.$store.getters.getSitesUpdates;
    },
    rawUpdates() {
      let selectedSites = this.getSelectedSites;
      let selectedGroupID = this.selectedGroup;
      this.selectedUpdatesCount = 0;
      if (this.viewIgnore == 'vulnerability') {
        var vulnsUpdates = this.$store.getters.getVulnerabilityUpdates(this.viewIgnore);
        var siteUpdates = _.filter(vulnsUpdates, { hiddenItem: false });
      }else{
        var siteUpdates = this.$store.getters.getUpdates(this.viewIgnore);
      }
      // let viewIgnore = this.viewIgnore;
      // siteUpdates = _.filter(siteUpdates, { hiddenItem: viewIgnore });
      let updates = [];
      _.each(siteUpdates, siteUpdate => {
        let siteId = siteUpdate.siteID;
        let site = {}
        if (selectedGroupID) {
          site = _.find(selectedSites, obj =>{
            let isGroup = _.indexOf(obj.groupIDs, selectedGroupID);
            if (obj.siteID ==siteId && isGroup != -1 ) {
               return obj;
            }
          });
        }else{
          site = _.find(selectedSites, { siteID: siteId});
        }
        if (site) {
          siteUpdate.siteName = site.name;
          if (siteUpdate.selected) {
            this.selectedUpdatesCount++;
          }
          updates.push(siteUpdate);
        }
      });
      return updates;
    },
    updates() {
      let updates = [];
      if (this.search) {
        updates = _.filter(this.rawUpdates, site=>{
          if (site.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
            return site
          }
        })
      }else{
        updates = this.rawUpdates;
      }
      // site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
      let processedUpdates = {
        plugins: [],
        themes: [],
        core: [],
        translations: []
      };
      let sort = _.sortBy(updates, [data => data.name.toLowerCase()]);
      let groupByType = _.groupBy(sort, 'type');
      _.each(groupByType, (group, key) => {
        let groupByURI = _.groupBy(group, 'URI');
        processedUpdates[key] = _.chain(group)
          .groupBy('URI')
          .toPairs()
          .map(function(currentItem) {
            currentItem.push(currentItem[1][0].name);
            return _.zipObject(['URI', 'sites', 'name'], currentItem);
          })
          .value();
      });

      return processedUpdates;
    },
    updatesBySite(){
      let updates = [];
      if (this.search) {
        updates = _.filter(this.rawUpdates, site=>{
          if (site.siteName.toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
            return site
          }
        })
      }else{
        updates = this.rawUpdates;
      }

      let processedUpdates = {};
      let increment = 1;
      let groupBySites = _.groupBy(updates, 'siteName');
      _.each(groupBySites, (site, key) => {
        if (this.paginate <= increment) {
          return false;
        }
        let sort = _.sortBy(site, 'type');
        let groupByURI = _.groupBy(sort, 'type');
        processedUpdates[key] = groupByURI
        increment++;
      });
      return processedUpdates;
    },
    getGroups(){
      let allGroups = this.$store.getters.getGroups;
      return  _.sortBy(allGroups, [data => data.name.toLowerCase()]);
    },
    showUpdateStaging(){
      if (typeof this.$store.getters.getSettings.staging != "undefined" &&  this.$store.getters.getSettings.staging.updateInStagingSwitchSettings == 1) {
        return true;
      }else{
        return false;
      }
    }
  },
  mounted(){
    this.loadWPVulns();
    let query = this.$route.query
    if (query.show=='vulnsupdate') {
      this.viewIgnore = 'vulnerability';
    }
    EventBus.$on('showvulnsupdate', data => {
        if (data) {
          this.viewIgnore = 'vulnerability';
        }
    });
    setTimeout(()=>{
      this.isLoading = false;
    });
  },
  watch:{
    viewIgnore(){
      if (this.selectedView == 'website') {
        this.select({type:'websites', value:false});
      }else{
        this.select({type:this.selectedView, value:false});
      }
    }
  },
  methods: {
    getNameByURI(URI) {
      if (URI === 'true') {
        URI = true;
      }
      let update = _.find(this.getSitesUpdates, { URI: URI });
      return update.name;
    },
    showConfirmationPopup() {
      this.showUpdatePopup = true;
    },
    select(payload) {
      let sites = [];
      if (payload.type == 'websites') {
          if (this.search) {
            sites = _.filter(this.rawUpdates, site=>{
              if (site.siteName.toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
                return site;
              }
            });
          }else{
            sites = this.rawUpdates;
          }
      }else{
        if (this.search) {
          sites = _.filter(this.rawUpdates, site=>{
            if (site.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 && site.type == payload.type) {
              return site;
            }
          });
        }else{
          sites = _.filter(this.rawUpdates, { type: payload.type })
        }
      }
      this.$store.commit({
        type: 'SELECT_GROUP_UPDATES',
        sites: sites,
        value: payload.value
      });
    },
    update(event) {
      this.buttonLoaders.update = true;
      let payload = {};
      payload.action = 'updateAll';
      payload.args = {};
      payload.args.params = {};
      let updateArray = {};
      let selectedUpdates = {};
      if (event.value == 'website') {
        selectedUpdates = _.filter(this.rawUpdates, { selected: true });
      }else{
        selectedUpdates = event.value;
      }

      let groupBySites = _.groupBy(selectedUpdates, 'siteID');
      _.each(groupBySites, (sites, siteId) => {
        if (updateArray[siteId] == undefined) {
          updateArray[siteId] = {};
        }
        _.each(sites, site => {
          if (site.type === 'core') {
            updateArray[siteId][site.type] = site.URI;
          } else {
            if (updateArray[siteId][site.type] == undefined) {
              updateArray[siteId][site.type] = [];
            }
            updateArray[siteId][site.type].push(site.URI);
          }
        });
      });

      payload.args.params = updateArray;
      payload.requiredData = {
        getSitesUpdatesV3: 1
      };
      return this.$store
        .dispatch('sendAction', payload)
        .then(() => {
          this.buttonLoaders.update = false;
          this.$refs.updatemodal.$refs.updatemodal.hide();
          this.$store.commit('REMOVE_SITES_UPDATES', selectedUpdates);
          
        })
        .catch(err => {
          
        });
    },
    ignore(selectedParams) {
      this.buttonLoaders.ignore = true;
      let payload = {};
      payload.requiredData = {};
      payload.requiredData['addHideV3'] = {};
      let selectedUpdates = {};
      if (selectedParams.value == 'website') {
        selectedUpdates = _.filter(this.rawUpdates, { selected: true });
      }else{
        selectedUpdates = selectedParams.value;
      }
      let updateArray = {};
      _.each(selectedUpdates, update => {
        if (updateArray[update.siteID] == undefined) {
          updateArray[update.siteID] = [];
        }
        updateArray[update.siteID].push({
          name: update.name,
          path: update.URI,
          type: update.type
        });
      });
      payload.requiredData['addHideV3'] = updateArray;
      payload.requiredData['getSitesUpdatesV3'] = 1;

      return this.$store
        .dispatch('sendAction', payload)
        .then(response => {
          this.$store.commit('REMOVE_SITES_UPDATES', selectedUpdates);
          this.$store.commit(
            'UPDATE_SITES_UPDATES',
            response.data.getSitesUpdatesV3
          );
          this.buttonLoaders.ignore = false;
          
        })
        .catch(err => {
          
        });
    },
    unIgnore(event) {
      this.buttonLoaders.unIgnore = true;
      let payload = {};
      payload.requiredData = {};
      payload.requiredData['removeHideV3'] = {};
      let selectedUpdates = {};
      if (event.value == 'website') {
        selectedUpdates = _.filter(this.rawUpdates, { selected: true });
      }else{
        selectedUpdates = event.value;
      }
      let updateArray = {};
      _.each(selectedUpdates, update => {
        if (updateArray[update.siteID] == undefined) {
          updateArray[update.siteID] = [];
        }
        updateArray[update.siteID].push({
          name: update.name,
          path: update.URI,
          type: update.type
        });
      });
      payload.requiredData['removeHideV3'] = updateArray;
      payload.requiredData['getSitesUpdatesV3'] = 1;
      return this.$store
        .dispatch('sendAction', payload)
        .then(response => {
          this.buttonLoaders.unIgnore = false;
          
          this.$store.commit('REMOVE_SITES_UPDATES', selectedUpdates);
          this.$store.commit(
            'UPDATE_SITES_UPDATES',
            response.data.getSitesUpdatesV3
          );
        })
        .catch(err => {
          
        });
    },
    updateAll() {
      setTimeout(() => {
        this.$refs.updatemodal.$refs.updatemodal.show();
      }, 100);
    },
    tabSelected(index) {
      this.currentTabIndex = index;
    },
    isHavingWPVulns() {
      let installedAddons = this.$store.getters.getInstalledAddons;
      return _.indexOf(installedAddons,'WPVulns') > -1;
    },
    loadWPVulns(){
      if (this.isHavingWPVulns()) {
        this.options.push({text: 'Vulnerability', value: 'vulnerability'})
      }
    },
    updatePagination(value){
      this.paginate+= value;
    },
    dynamicPagination(value){
      this.paginate = value;
    }
  }
};
</script>

<style >
</style>
